import { useEffect } from 'react'
import { adminSocketService } from '../services/socketService'

export function useAdminSocketInit() {
  useEffect(() => {
    const token = localStorage.getItem('auth_token')
    if (token && !adminSocketService.connected) {
      adminSocketService.connect(token)
    }
  }, [])
}
